import script from "./DialogTraceSource.vue?vue&type=script&setup=true&lang=ts"
export * from "./DialogTraceSource.vue?vue&type=script&setup=true&lang=ts"

import "./DialogTraceSource.vue?vue&type=style&index=0&id=ba881006&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba881006"]])

export default __exports__